// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3yP8k","title":"AfterFrontImage_title__2SJHr"};